import React, {useEffect, useState} from 'react';
import {
  StyleSheet,
  View,
  Modal,
  Dimensions,
  StatusBar,
  useColorScheme,
  TouchableWithoutFeedback,
} from 'react-native';
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withTiming,
  runOnJS,
  withRepeat,
  Easing,
  useDerivedValue,
} from 'react-native-reanimated';
import {useTutorial} from '../../../context/TutorialProvider';
import {GlobalMask} from '../Step/GlobalMask';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {useNavigation} from '@react-navigation/native';
import {TouchableOpacity} from 'react-native-gesture-handler';

import Icon from 'react-native-vector-icons/Feather';

import {RFValue} from 'react-native-responsive-fontsize';

const {width: screenWidth, height: screenHeight} = Dimensions.get('screen');

export const TutorialModal = () => {
  const {
    currentStep,
    isActive,
    activeSteps,
    currentActiveStep,
    hasMoreSteps,
    nextStep,
    setCurrentStep,
    setSteps,
    endTutorial,
  } = useTutorial();
  const insets = useSafeAreaInsets();
  const theme = useColorScheme();

  const adjustedInsets = {
    top: insets.top || StatusBar.currentHeight || 0,
    bottom: insets.bottom || 20,
  };

  const [tooltipHeight, setTooltipHeight] = useState(0);
  const [visibleText, setVisibleText] = useState('');

  const typingProgress = useSharedValue(0);
  
  const pulse = useSharedValue(0);

  const navigation = useNavigation();

  // Usa currentActiveStep ao invés de steps[currentStep]
  const step = currentActiveStep;
  const position = step?.position || {x: 0, y: 0, width: 0, height: 0};

  useEffect(() => {
    if (isActive && step) {
      typingProgress.value = 0;
      runOnJS(setVisibleText)('');
      typingProgress.value = withTiming(1, {
        duration: step.text.length * 50,
      });

      // Inicia o efeito pulsante
      if (step.onPress) {
        pulse.value = 0;
        pulse.value = withRepeat(
          withTiming(1, {
            duration: 800,
            easing: Easing.inOut(Easing.ease),
          }),
          -1,
          true,
        );
      } else {
        pulse.value = 0;
      }
    }
  }, [isActive, step]);

  useDerivedValue(() => {
    const length = Math.floor(
      typingProgress.value * (step?.text.length || 0),
    );
  
    if (step?.text) {
      runOnJS(setVisibleText)(step.text.slice(0, length));
    }
  }, [step]);
  

  const pulseStyle = useAnimatedStyle(() => {
    const scale = pulse.value; // Varia entre 0 e 1
    const borderSize = 25; // Margem inicial

    const calculatedWidth = position.width - scale * borderSize + 30;
    const calculatedLeft = position.x + (scale * borderSize) / 2 - 15;

    const exceedsHorizontalBounds =
      calculatedLeft < 0 || calculatedLeft + calculatedWidth > screenWidth;

    return {
      width: position.width - scale * borderSize + 30,
      height: position.height - scale * borderSize + 25,
      top: position.y + (scale * borderSize) / 2 - 12.5,
      left: position.x + (scale * borderSize) / 2 - 15,
      borderRadius: exceedsHorizontalBounds ? 0 : 10,
      borderColor: '#f70',
      borderWidth: 3,
    };
  });

  const getTooltipPosition = () => {
    const tooltipWidth = RFValue(225);
    const offset = 10;

    let top = position.y + position.height + offset;
    let left = position.x + position.width / 2 - tooltipWidth / 2;

    if (top + tooltipHeight > screenHeight - adjustedInsets.bottom) {
      top = position.y - tooltipHeight - offset;
    } else if (top < adjustedInsets.top) {
      top = adjustedInsets.top + offset;
    }

    if (left + tooltipWidth > screenWidth) {
      left = screenWidth - tooltipWidth - offset;
    } else if (left < 0) {
      left = offset;
    }

    return {top, left};
  };

  const tooltipPosition = getTooltipPosition();

  if (!isActive || !step) return null;

  function actionButton() {
    if (step?.onPress) {
      step.onPress();
      setCurrentStep(currentStep + 1);
    }
  }

  function prevStepAction() {
    const prevStepIndex = currentStep - 1;

    if (prevStepIndex >= 0) {
      const previousStep = activeSteps[prevStepIndex];

      // Verifique se a tela atual é diferente da tela da etapa anterior
      if (previousStep.screen && previousStep.screen !== step?.screen) {
        // Remova todas as etapas após a etapa para a qual estamos voltando
        const updatedSteps = activeSteps.filter((_, index) => index <= prevStepIndex);

        // Atualize o estado das etapas
        setSteps(updatedSteps);

        // Navegar para a tela correspondente
        //@ts-ignore
        navigation.navigate(previousStep.screen, previousStep.params);
      }

      // Atualize a etapa atual para a anterior
      setCurrentStep(prevStepIndex);
    }
  }

  return (
    <Modal transparent visible animationType="none">
      <GlobalMask
        //@ts-ignore
        highlightX={position.x}
        //@ts-ignore
        highlightY={position.y}
        //@ts-ignore
        highlightWidth={position.width}
        //@ts-ignore
        highlightHeight={position.height}
        additionalWidth={step.additionalWidth}
        additionalHeight={step.additionalHeight}
        skipOnBackpress={step.skipOnBackpress}
        customY={step.customY}
        customX={step.customX}
        borderRadius={10}
        onPress={actionButton}
      />

      {/* Retângulo pulsante */}
      {step?.onPress && (
        <TouchableWithoutFeedback onPress={actionButton}>
          <Animated.View
            style={[
              styles.pulseRectangle,
              pulseStyle,
              {
                top: position.y,
                left: position.x,
                width: position.width,
                height: position.height,
              },
            ]}
          />
        </TouchableWithoutFeedback>
      )}
      <Animated.View
      onTouchStart={() => {
        endTutorial(), navigation.navigate("Initial")
      }}
        style={{
          zIndex: 999,
          elevation: 999,
          position: 'relative',
          top: tooltipPosition.top - RFValue(10),
          left: tooltipPosition.left,
          marginLeft: RFValue(208),
        }}>
        <TouchableOpacity
        activeOpacity={.7}
          style={{
            width: RFValue(24),
            height: RFValue(24),
            backgroundColor: '#F00',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 24,
            
            borderWidth: 1,
            borderColor: 'white',
          }}
          onPress={() => {
            endTutorial(), navigation.navigate("Initial")
          }}>
          {
            //@ts-ignore
            <Icon name="x" style={{fontSize: RFValue(16), color: '#FFF'}} />
          }
        </TouchableOpacity>
      </Animated.View>
      <View
        onLayout={event => {
          const {height} = event.nativeEvent.layout;
          setTooltipHeight(height);
        }}
        style={[
          styles.tooltip,
          {
            width: RFValue(225),
            backgroundColor: theme === 'dark' ? '#222' : '#FFF',
            top: tooltipPosition.top,
            left: tooltipPosition.left,
          },
        ]}>
        <Animated.Text
          style={[
            styles.tooltipText,
            {color: theme === 'dark' ? '#FFF' : '#222'},
          ]}>
          {visibleText}
        </Animated.Text>

        <View style={styles.buttons}>
          {currentStep > 0 && (
            <Animated.Text
              style={{...styles.button, fontFamily: 'Poppins-Regular'}}
              onPress={prevStepAction}>
              Voltar
            </Animated.Text>
          )}
          {hasMoreSteps
            ? !step?.onPress && (
                <Animated.Text style={styles.button} onPress={nextStep}>
                  Próximo
                </Animated.Text>
              )
            : !step?.onPress && (
                <Animated.Text
                  style={styles.button}
                  onPress={() => {
                    endTutorial(), navigation.navigate('Initial');
                  }}>
                  Finalizar tutorial
                </Animated.Text>
              )}
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  tooltip: {
    position: 'absolute',
    borderRadius: 10,
    padding: 10,
  },
  tooltipText: {
    fontSize: RFValue(12),
    marginBottom: 10,
    fontFamily: 'Poppins-Regular',
  },
  buttons: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 12,
    width: '100%',
  },
  button: {
    fontSize: RFValue(12),
    color: '#007BFF',
    fontFamily: 'Poppins-SemiBold',
  },
  pulseRectangle: {
    position: 'absolute',
    backgroundColor: 'transparent',
    borderRadius: 10,
  },
});